import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { mapContentSeriesAdminFieldsToBody } from './mappers/adminContentSeriesMapper';
import type { ContentSeriesAdminFields } from './types';

/** Studio-admin only. Returns the updated series through the regular series serializer. */
export async function updateContentSeriesAdminFields(
  artistId: string,
  contentSeriesId: string,
  fields: ContentSeriesAdminFields
) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentSeriesId) throw Error('Content Series ID is required');

  const url = `/web/studio/artists/${artistId}/content-series/${contentSeriesId}/admin-fields`;
  const body = mapContentSeriesAdminFieldsToBody(fields);

  const response = await api.executePutRequest<ObjectResponse<Record<string, unknown>>>(url, body);

  return response.data;
}
